import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import EntitySelectDialog from '../../components/EntitySelectDialog/EntitySelectDialog';
import Language from '../../types/Language';
import { StyledAvatar, StyledFlag } from './styled';

interface Props {
    open: boolean;
    onClose: () => void;
    languages: Language[];
}

const LanguageSelectDialog = (props: Props) => {
    const { open, onClose, languages } = props;

    const { t, i18n } = useTranslation();

    const title = t('dialogs.language_select.title');

    const changeLanguage = useCallback((languageId?: number) => {
        const selectedLanguage = languages.find(language => language.id === languageId);
        if (selectedLanguage) {
            i18n.changeLanguage(selectedLanguage.code);
        }
        onClose();
    }, [i18n, languages, onClose]);

    const dataForRender = useMemo(() => {
        return languages.map(language => {
            const countryCode = language.code.split('-').pop();
            return {
                id: language.id,
                name: language.description,
                image: (
                    <ListItemAvatar>
                        <StyledAvatar>
                            <StyledFlag code={countryCode} />
                        </StyledAvatar>
                    </ListItemAvatar>
                )
            };
        });
    }, [languages]);

    return (
        <EntitySelectDialog
            open={open}
            onClose={changeLanguage}
            title={title}
            data={dataForRender}
        />
    );
};


export default LanguageSelectDialog;
